/* Un formulaire, plusieurs accès. Initialisation compatible éditeur Shopify. */
(function () {
  function init(root) {
    root.querySelectorAll('[data-lms-page]').forEach(function (page) {
      if (page.dataset.lmsBound) return;
      page.dataset.lmsBound = 'true';
      page.querySelectorAll('[data-lms-focus]').forEach(function (link) {
        link.addEventListener('click', function (event) {
          var email = page.querySelector('input[type="email"]');
          var capture = page.querySelector('[data-lms-capture]');
          if (!email || !capture) return;
          event.preventDefault();
          capture.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          email.focus({ preventScroll: true });
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
